import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-confing/http/http-client.service';
import { Component } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class ProjcarouselService {
 
  constructor(private http:HttpClientService) { }
  }
  

